<!-- 树状选择器 -->
<template>
  <el-select
    v-model="sValue"
    :placeholder="placeholder"
    :size="size"
    :style="multiple?`width: ${width}px;min-height: ${height}px;`:`width: ${width}px;height: ${height}px;line-height: ${height}px;`"
    :loading="loading"
    :loading-text="loadingText"
    filterable
    :multiple="multiple"
    :disabled="disabled"
    :change="valueChange"
    clearable>
    <el-option
      v-for="code in options"
      :key="code.codeItemId"
      :label="code.codeName"
      :value="code.codeItemId"/>
  </el-select>
</template>

<script>
import { getCodeListBySetId } from  "@/api/sys/code"
export default {
  name: 'Pagination',
  props: {
    // 接收绑定参数
    value: {
      type: String,
      default: ''
    },
    // 接收绑定参数
    codeSetId: {
      type: String,
      default: ''
    },
    // 输入框宽度
    width: {
      type: String,
      default: '200'
    },
    // 输入框高度
    height: {
      type: String,
      default: '28'
    },
    // input框的大小
    size: {
      type: String,
      default: ''
    },
    // 输入框占位符
    placeholder: {
      type: String,
      required: false,
      default: '请选择'
    },
    /*多选*/
    multiple:{
      type: Boolean,
      default: ()=>{ return false }
    },
    disabled:{
      type: Boolean,
      default: ()=>{ return false }
    },
    options:{
      type: Array,
      default: ()=>{ return [] }
    }
  },
  data() {
    return {
      // 输入框显示值
      labelModel: '',
      loading: true,
      loadingText: '加载中',
      sValue: ''
    }
  },
  watch: {
    // 判断下拉框的值是否有改变
    sValue(val, oldVal) {
      // console.log('new: %s, old: %s', val, oldVal)
      if (val !== oldVal) {
        this.$emit('input', this.sValue)
        this.$emit('selectChange')
      }
    },
    value(val, oldVal) {
      if (val !== oldVal) {
        this.$set(this, 'sValue', val)
      }
    }
  },
  mounted() {
    // 初始话下拉框的值
    this.sValue = this.value
    if(this.options.length>0){
      this.loading=false
    }else{
      this.initData()
    }
  },
  methods: {
    initData() {
      var that = this
      if (this.codeSetId) {
        // 获取随机数  防止被后台重复提交拦截
        //var randomNum = new Date().getTime() + '' + Math.floor(Math.random() * 900000) + 100
        // 加载代码项
        getCodeListBySetId(that.codeSetId).then(resp => {
          if(resp.data.code==0){
            this.options=resp.data.data
          }
          this.loading=false
        })
      } else {
        this.loading=false
      }
    },
    //当值改变后 更新父组件的值
    valueChange(val){
      this.$emit("input", val);
      this.$emit("selectChange", val);
    }
  }
}
</script>

<style>
  .el-input.el-input--suffix {
    cursor: pointer;
    overflow: hidden;
  }

  .el-input.el-input--suffix.rotate .el-input__suffix {
    transform: rotate(180deg);
  }

  .select-tree {
    max-height: 350px;
    overflow-y: scroll;
  }

  /* 菜单滚动条 */
  .select-tree::-webkit-scrollbar {
    z-index: 11;
    width: 6px;
  }

  .select-tree::-webkit-scrollbar-track,
  .select-tree::-webkit-scrollbar-corner {
    background: #fff;
  }

  .select-tree::-webkit-scrollbar-thumb {
    border-radius: 5px;
    width: 6px;
    background: #b4bccc;
  }

  .select-tree::-webkit-scrollbar-track-piece {
    background: #fff;
    width: 6px;
  }
</style>
